import { render } from "./TestTitle.vue?vue&type=template&id=5bccb813&scoped=true"
import script from "./TestTitle.vue?vue&type=script&lang=js"
export * from "./TestTitle.vue?vue&type=script&lang=js"

import "./TestTitle.vue?vue&type=style&index=0&id=5bccb813&lang=scss&scoped=true"

import exportComponent from "/Volumes/TRENTDEVELOPMENT/www/classmarker_pre_release_production/web_apps/test-interface/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bccb813"]])

export default __exports__